import { render, staticRenderFns } from "./lawManage.vue?vue&type=template&id=fa64ebf8"
import script from "./lawManage.vue?vue&type=script&lang=js"
export * from "./lawManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa64ebf8')) {
      api.createRecord('fa64ebf8', component.options)
    } else {
      api.reload('fa64ebf8', component.options)
    }
    module.hot.accept("./lawManage.vue?vue&type=template&id=fa64ebf8", function () {
      api.rerender('fa64ebf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/lawManage.vue"
export default component.exports